import React from 'react';
import Text from 'admin/components/common/Text';
import css from './ResourceEditor.scss';

export default function ResourceEmptyState({
	title,
	description,
	icon,
	action,
	inset = false,
}: {
	title: string;
	description: string;
	icon?: React.ReactNode;
	action: React.ReactNode;
	inset?: boolean;
}) {
	return (
		<div className={css.emptyState} data-inset={inset}>
			{icon && (
				<span className={css.emptyIcon} aria-hidden="true">
					{icon}
				</span>
			)}
			<Text tag="h3" size={Text.size.body} weight={Text.weight.semibold} compact className={css.emptyTitle}>
				{title}
			</Text>
			<Text tag="p" size={Text.size.label} compact className={css.emptyDescription}>
				{description}
			</Text>
			{action}
		</div>
	);
}
